import { AbstractModel } from "./abstract-model";

export class PlanoSuporte extends AbstractModel {
  descricao: string;
}
